import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { theme, VStack } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientsStack = memo(
  (props: PropsWithChildren) => {
    return (
      <VStack
        style={styles.container}
        gap={theme.spacing['8']}
        dividerColor={theme.colors.LIGHT}
        hasDivider
      >
        {props.children}
      </VStack>
    );
  },
);

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingVertical: theme.spacing['6'],
  },
});
